import { getEventSchedule } from "@/helpers/server-actions/events-collection";
import { EventItem, MySchedule } from "@/models/event-item";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  schedule: EventItem[];
  mySchedule: MySchedule[];
  selectedEventId: string;
  loading: boolean;
};

const initialState: InitialState = {
  schedule: [],
  mySchedule: [],
  loading: false,
  selectedEventId: "",
};

// create async thunk for attaching a snapshot listener to the schedule collection

// create async thunk for fetching schedule
export const fetchEventSchedule = createAsyncThunk(
  "schedule/fetchSchedule",
  async () => {
    let schedule = await getEventSchedule();
    schedule = schedule.filter((event) => !event.isCanceled);
    schedule = schedule.sort((a: EventItem, b: EventItem) => {
      const dateTimeA = new Date(a.startTime.seconds * 1000);
      const dateTimeB = new Date(b.startTime.seconds * 1000);
      const timeA = dateTimeA.getTime();
      const timeB = dateTimeB.getTime();
      return timeA - timeB;
    });
    return schedule;
  }
);

export const scheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    setSchedule: (state, action: PayloadAction<EventItem[]>) => {
      state.schedule = action.payload;
    },

    setMySchedule: (state, action: PayloadAction<MySchedule[]>) => {
      state.mySchedule = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchEventSchedule.fulfilled, (state, action) => {
      state.schedule = action.payload;
      state.loading = false; 
    });
    builder.addCase(fetchEventSchedule.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchEventSchedule.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setSchedule, setMySchedule } = scheduleSlice.actions;

export default scheduleSlice.reducer;
